import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = { class: "container mar_b" }
const _hoisted_4 = { class: "t6_breadCream" }
const _hoisted_5 = { class: "right_table" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "t6_pager" }

import { getNewsContentList } from '@/config/request';
import { reactive, ref, toRefs } from 'vue';
import { useRoute, useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'friendly-news-list',
  setup(__props) {

const router = useRouter()
const route = useRoute()

const themeId = route.query.themeId
const typeName = route.query.typeName
const newsList = ref([]) as any
const pagination = reactive({
    pageNo: 1,
    pageSize: 10,
})


const getNewsList = async() => {
    let param = {
        themeId: themeId,
        typeName: typeName,
        pageNo: pagination.pageNo,
        pageSize: pagination.pageSize
    }
    console.log('param',param);

    const res = await getNewsContentList(param) as any
    newsList.value = res.result

}

const showDetail = (item:any) => {
    router.push({
        path: '/friendly-news-detail',
        query:{
            id: item.id
        }
    })
}
const handleCurrentChange = (index:any) => {
    pagination.pageNo = index
    getNewsList()
}
getNewsList()

return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Bottom = _resolveComponent("Bottom")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[4] || (_cache[4] = _createElementVNode("div", {
      class: "no_banner",
      id: "no_banner"
    }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "污染防治", -1)),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _cache[2] || (_cache[2] = _createElementVNode("i", null, ">", -1)),
            _createElementVNode("span", null, _toDisplayString(_unref(typeName)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_table, {
              data: newsList.value.records,
              size: "large"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  type: "index",
                  label: "序号",
                  width: "100",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "标题",
                  width: "600",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("a", {
                      type: "primary",
                      onClick: ($event: any) => (showDetail(scope.row))
                    }, _toDisplayString(scope.row.title), 9, _hoisted_6)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "releaseDate",
                  label: "发布时间",
                  width: "300",
                  align: "center"
                }),
                _createVNode(_component_el_table_column, {
                  label: "操作",
                  width: "200",
                  align: "center"
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: ($event: any) => (showDetail(scope.row))
                    }, {
                      default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createTextVNode("查看", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_pagination, {
                background: "",
                onCurrentChange: handleCurrentChange,
                layout: "prev, pager, next, total",
                "page-size": pagination.pageSize,
                total: newsList.value.total
              }, null, 8, ["page-size", "total"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})